import React from "react";
import { Box, Container, Skeleton } from "@mui/material";

function HomeSkeleton() {
  return (
    <Box
      sx={{
        height: "100vh",
        backgroundColor: "grey.300",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Container>
        <Box sx={{ textAlign: "center" }}>
          <Skeleton
            variant="rectangular"
            width="80%"
            height={60}
            sx={{ 
              mx: 'auto', 
              mb: 3,
              bgcolor: 'grey.400',
              borderRadius: 1
            }}
          />
          <Skeleton
            variant="rectangular"
            width={200}
            height={50}
            sx={{ 
              mx: 'auto',
              bgcolor: 'grey.400',
              borderRadius: 2
            }}
          />
        </Box>
      </Container>
    </Box>
  );
}

export default HomeSkeleton;